exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb-anchor[data-v-11eb070a]:before{display:block;content:\" \";margin-top:-56px;height:56px;visibility:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11eb070a","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/BreadcrumbAnchor.vue
// module id = 74
// module chunks = 0 1 2 3 4 5 6 10 12